export default __webpack_public_path__ + "static/media/kexamples.3d57d4f7.png";